var ifla=false;
export default {

    Frames:function(){
        document.querySelector('video').style['pointer-events'] = 'none'
        // $('#mask_bg').on('mouseup',function () { 
        //     // document.documentElement.addEventListener('mousemove',console.log(22))
        //     document.querySelector('video').style['pointer-events'] = 'auto'
        //     $('.frames').unbind('mousemove');
        // });
        // $('.frames').on('mouseup',function () { 
        //     // document.documentElement.addEventListener('mousemove',console.log(22))
        //     document.querySelector('video').style['pointer-events'] = 'auto'
        //     $('.frames').unbind('mousemove');
        // });
        
        var mouseUp = function(event){
            document.querySelector('video').style['pointer-events'] = 'auto'
            locx=event.screenX,locy=event.screenY
            document.removeEventListener('mousemove',mouseMove)
        }
        document.addEventListener('mouseup',mouseUp)
        var frame=document.documentElement.getElementsByClassName('frames')[0]
        var frameX=document.documentElement.getElementsByClassName('frames')[0].getBoundingClientRect().left
        var frameY=document.documentElement.getElementsByClassName('frames')[0].getBoundingClientRect().top
        var locx,locy
        var mouseMove = function(e){
            // console.log(frameX+e.screenX-locx+'px')
            frame.style.left=frameX+e.screenX-locx+'px'
            frame.style.top=frameY+e.screenY-locy+'px'
            frameX=document.documentElement.getElementsByClassName('frames')[0].getBoundingClientRect().left
            frameY=document.documentElement.getElementsByClassName('frames')[0].getBoundingClientRect().top
            locx=e.screenX,locy=e.screenY
            if(frameX<0){
                frame.style.left=0+'px'
            }
            if(frameY<0){
                frame.style.ltop=0+'px'
            }
            var height=window.innerHeight|| document.documentElement.clientHeight,width=window.innerWidth|| document.documentElement.clientWidth
            if(frameX+document.documentElement.getElementsByClassName('frames')[0].getBoundingClientRect().width-width>0){
                frame.style.left=width-document.documentElement.getElementsByClassName('frames')[0].getBoundingClientRect().width+'px'
            }
            if(frameY+document.documentElement.getElementsByClassName('frames')[0].getBoundingClientRect().height-height>0){
                frame.style.top=height-document.documentElement.getElementsByClassName('frames')[0].getBoundingClientRect().height+'px'
            }
        }
        $('.frames').on('mousedown',function (event) { 
            if(ifla){
                return
            }
            document.querySelector('video').style['pointer-events'] = 'none'
            locx=event.screenX,locy=event.screenY
            // var mouseMove = function(e){
            //     // console.log(frameX+e.screenX-locx+'px')
            //     frame.style.left=frameX+e.screenX-locx+'px'
            //     frame.style.top=frameY+e.screenY-locy+'px'
            //     frameX=document.documentElement.getElementsByClassName('frames')[0].getBoundingClientRect().left
            //     frameY=document.documentElement.getElementsByClassName('frames')[0].getBoundingClientRect().top
            //     locx=e.screenX,locy=e.screenY
            //     if(frameX<0){
            //         frame.style.left=0+'px'
            //     }
            //     if(frameY<0){
            //         frame.style.ltop=0+'px'
            //     }
            //     var height=window.innerHeight|| document.documentElement.clientHeight,width=window.innerWidth|| document.documentElement.clientWidth
            //     if(frameX+document.documentElement.getElementsByClassName('frames')[0].getBoundingClientRect().width-width>0){
            //         frame.style.left=width-document.documentElement.getElementsByClassName('frames')[0].getBoundingClientRect().width+'px'
            //     }
            //     if(frameY+document.documentElement.getElementsByClassName('frames')[0].getBoundingClientRect().height-height>0){
            //         frame.style.top=height-document.documentElement.getElementsByClassName('frames')[0].getBoundingClientRect().height+'px'
            //     }
            // }
            document.addEventListener('mousemove',mouseMove)

            // $('.#mask_bg').on('mousedown',function(e){
            //     // console.log(frameX+e.screenX-locx+'px')
            //     frame.style.left=frameX+e.screenX-locx+'px'
            //     frame.style.top=frameY+e.screenY-locy+'px'
            //     frameX=document.documentElement.getElementsByClassName('frames')[0].getBoundingClientRect().left
            //     frameY=document.documentElement.getElementsByClassName('frames')[0].getBoundingClientRect().top
            //     locx=e.screenX,locy=e.screenY
            //     if(frameX<0){
            //         frame.style.left=0+'px'
            //     }
            //     if(frameY<0){
            //         frame.style.ltop=0+'px'
            //     }
            //     var height=window.innerHeight|| document.documentElement.clientHeight,width=window.innerWidth|| document.documentElement.clientWidth
            //     if(frameX+document.documentElement.getElementsByClassName('frames')[0].getBoundingClientRect().width-width>0){
            //         frame.style.left=width-document.documentElement.getElementsByClassName('frames')[0].getBoundingClientRect().width+'px'
            //     }
            //     if(frameY+document.documentElement.getElementsByClassName('frames')[0].getBoundingClientRect().height-height>0){
            //         frame.style.top=height-document.documentElement.getElementsByClassName('frames')[0].getBoundingClientRect().height+'px'
            //     }
            // });
        });
        },
    La:function(){
        console.log(ifla)
        var lac='<div class="frame-resize nw-resize"></div>\
        <div class="frame-resize n-resize"></div>\
        <div class="frame-resize ne-resize"></div>\
        <div class="frame-resize e-resize"></div>\
        <div class="frame-resize w-resize"></div>\
        <div class="frame-resize s-resize"></div>\
        <div class="frame-resize se-resize"></div>\
        <div class="frame-resize sw-resize"></div>\
        '
        console.log(lac)
        $('.frames').append(lac);
        $('.nw-resize').on('mousedown',function(event){
            ifla=true
            document.querySelector('video').style['pointer-events'] = 'none'
            var locx=event.clientX,locy=event.clientY
            var frame=document.documentElement.getElementsByClassName('frames')[0].getBoundingClientRect()
            $('#mask_bg').on('mousemove',function(e){   
                    console.log(e)        
                    $('.frames').css('top',e.clientY)
                    $('.frames').css('left',e.clientX)
                    $('.frames').css('height',frame.height+locy-e.clientY)
                    $('.frames').css('width',frame.width+locx-e.clientX)
                    locx=e.clientX,locy=e.clientY
                    frame=document.documentElement.getElementsByClassName('frames')[0].getBoundingClientRect()
            })
        })
        $('.n-resize').on('mousedown',function(event){
            ifla=true
            document.querySelector('video').style['pointer-events'] = 'none'
            var locx=event.clientX,locy=event.clientY
            var frame=document.documentElement.getElementsByClassName('frames')[0].getBoundingClientRect()
            $('#mask_bg').on('mousemove',function(e){                
                    $('.frames').css('top',e.clientY)
                    $('.frames').css('height',frame.height+locy-e.clientY)
                    locx=e.clientX,locy=e.clientY
                    frame=document.documentElement.getElementsByClassName('frames')[0].getBoundingClientRect()
            })
        })
        $('.ne-resize').on('mousedown',function(event){
            ifla=true
            document.querySelector('video').style['pointer-events'] = 'none'
            var locx=event.clientX,locy=event.clientY
            var frame=document.documentElement.getElementsByClassName('frames')[0].getBoundingClientRect()
            $('#mask_bg').on('mousemove',function(e){                
                    $('.frames').css('top',e.clientY)
                    $('.frames').css('height',frame.height+locy-e.clientY)
                    $('.frames').css('width',e.clientX-frame.left)
                    locx=e.clientX,locy=e.clientY
                    frame=document.documentElement.getElementsByClassName('frames')[0].getBoundingClientRect()
            })
        })
        $('.e-resize').on('mousedown',function(event){
            ifla=true
            document.querySelector('video').style['pointer-events'] = 'none'
            var locx=event.clientX,locy=event.clientY
            var frame=document.documentElement.getElementsByClassName('frames')[0].getBoundingClientRect()
            $('#mask_bg').on('mousemove',function(e){                
                    $('.frames').css('width',e.clientX-frame.left)
                    locx=e.clientX,locy=e.clientY
                    frame=document.documentElement.getElementsByClassName('frames')[0].getBoundingClientRect()
            })
        })
        $('.se-resize').on('mousedown',function(event){
            ifla=true
            document.querySelector('video').style['pointer-events'] = 'none'
            var locx=event.clientX,locy=event.clientY
            var frame=document.documentElement.getElementsByClassName('frames')[0].getBoundingClientRect()
            $('#mask_bg').on('mousemove',function(e){                
                    $('.frames').css('height',e.clientY-frame.top)
                    $('.frames').css('width',e.clientX-frame.left)
                    locx=e.clientX,locy=e.clientY
                    frame=document.documentElement.getElementsByClassName('frames')[0].getBoundingClientRect()
            })
        })
        $('.s-resize').on('mousedown',function(event){
            ifla=true
            document.querySelector('video').style['pointer-events'] = 'none'
            var locx=event.clientX,locy=event.clientY
            var frame=document.documentElement.getElementsByClassName('frames')[0].getBoundingClientRect()
            $('#mask_bg').on('mousemove',function(e){                
                    $('.frames').css('height',e.clientY-frame.top)
                    locx=e.clientX,locy=e.clientY
                    frame=document.documentElement.getElementsByClassName('frames')[0].getBoundingClientRect()
            })
        })
        $('.sw-resize').on('mousedown',function(event){
            ifla=true
            document.querySelector('video').style['pointer-events'] = 'none'
            var locx=event.clientX,locy=event.clientY
            var frame=document.documentElement.getElementsByClassName('frames')[0].getBoundingClientRect()
            $('#mask_bg').on('mousemove',function(e){                
                    $('.frames').css('height',e.clientY-frame.top)
                    $('.frames').css('left',e.clientX)
                    $('.frames').css('width',frame.width+locx-e.clientX)
                    locx=e.clientX,locy=e.clientY
                    frame=document.documentElement.getElementsByClassName('frames')[0].getBoundingClientRect()
            })
        })
        $('.w-resize').on('mousedown',function(event){
            ifla=true
            document.querySelector('video').style['pointer-events'] = 'none'
            var locx=event.clientX,locy=event.clientY
            var frame=document.documentElement.getElementsByClassName('frames')[0].getBoundingClientRect()
            $('#mask_bg').on('mousemove',function(e){                
                    $('.frames').css('left',e.clientX)
                    $('.frames').css('width',frame.width+locx-e.clientX)
                    locx=e.clientX,locy=e.clientY
                    frame=document.documentElement.getElementsByClassName('frames')[0].getBoundingClientRect()
            })
        })
        $('#mask_bg').on('mouseup',function () { 
            document.querySelector('video').style['pointer-events'] = 'auto'
            $('#mask_bg').off('mousemove');
            ifla=false
        });
    }
}
